const headers = [
  { text: 'Học sinh', value: 'student', width: '300px' },
  { text: 'Lớp', value: 'class', width: '100px' },
  { text: 'Xe tuyến', value: 'bus', width: '80px' },
  { text: 'Chiều di chuyển', value: 'bus_schedule', width: '120px' },
  { text: 'Đi / Không đi', value: 'register', align: 'center', width: '100px' },
  { text: 'Điểm danh', value: 'attendance', align: 'center', width: '100px' },
  { text: 'GV phụ trách', value: 'driver', width: '150px' },
  { text: 'GV chủ nhiệm', value: 'headTeacher', width: '150px' },
  { text: 'Trạng thái', value: 'status', align: 'center', width: '100px' },
  { text: 'Thao tác', value: 'action', align: 'center', width: '130px' }
]

export const getHeaders = ({ role = {}, ownClassIds = [] }) => {
  if (role.type === 'teacher') {
    if (Array.isArray(ownClassIds) && ownClassIds.length) return headers.filter(x => x.value !== 'headTeacher')
    return headers.filter(x => x.value !== 'driver')
  }
  return headers
}
